<template>
    <div>
        <h1 class="display-heading">Patient QR Code Check In</h1>
        <tab-view :tabs="tabs" :activeTab.sync="activeTab">
            <template v-if="activeTab===0">
                <clinic-walk-in></clinic-walk-in>
            </template>
            <template v-if="activeTab===1">
                <clinic-qr></clinic-qr>
            </template>
        </tab-view>
    </div>
</template>

<script>
import tabView from '@/components/tab-view';
import clinicWalkIn from '@/components/clinic/patient-check-in';
import clinicQr from '@/components/clinic/qr';
export default {
    'name': 'PatientWalkIn',
    'components': {
        tabView,
        clinicWalkIn,
        clinicQr
    },
    data () {
        return {
            'tabs': ['Patient Check-In(s)', 'Clinic QR Code'],
            'activeTab': 0
        };
    }
};
</script>
